module.exports = __webpack_public_path__ + "img/order.a2b11db6.png";